import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function McpIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M15.688 2.343a2.588 2.588 0 00-3.61 0l-9.626 9.44a.863.863 0 01-1.203 0 .823.823 0 010-1.18l9.626-9.44a4.313 4.313 0 016.016 0 4.116 4.116 0 011.204 3.54 4.3 4.3 0 013.609 1.18l.05.05a4.115 4.115 0 010 5.9l-8.706 8.537a.274.274 0 000 .393l1.788 1.754a.823.823 0 010 1.18.863.863 0 01-1.203 0l-1.788-1.753a1.92 1.92 0 010-2.754l8.706-8.538a2.47 2.47 0 000-3.54l-.05-.049a2.588 2.588 0 00-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 01-1.204 0 .823.823 0 010-1.18l7.273-7.133a2.47 2.47 0 00-.003-3.537z" />
      <path d="M14.485 4.703a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a4.115 4.115 0 000 5.9 4.314 4.314 0 006.016 0l7.12-6.982a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a2.588 2.588 0 01-3.61 0 2.47 2.47 0 010-3.54l7.12-6.982z" />
    </SvgIcon>
  );
}

// xxllnc.ai brand logo: AI gradient square + wordmark. Recreated as SVG from
// public/xxlln_ai.png — teal (top) → indigo/purple → a luminous steel-blue glow
// at the bottom-right corner, matching the original artwork.
const AI_FONT = "'DM Sans', 'Plus Jakarta Sans', system-ui, sans-serif";

function AiSquare() {
  return (
    <>
      <defs>
        <linearGradient id="portalXxAiBase" x1="2" y1="2" x2="46" y2="46" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#123A3A" />
          <stop offset="0.42" stopColor="#262061" />
          <stop offset="0.72" stopColor="#3A2E78" />
          <stop offset="1" stopColor="#4C4C95" />
        </linearGradient>
        <radialGradient id="portalXxAiGlow" cx="0.82" cy="0.9" r="0.78">
          <stop offset="0" stopColor="#A6BEDA" stopOpacity="0.9" />
          <stop offset="0.45" stopColor="#6F8FB0" stopOpacity="0.35" />
          <stop offset="1" stopColor="#6F8FB0" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="48" height="48" rx="11" fill="url(#portalXxAiBase)" />
      <rect width="48" height="48" rx="11" fill="url(#portalXxAiGlow)" />
      <text
        x="24"
        y="25"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily={AI_FONT}
        fontSize="20"
        fontWeight="700"
        letterSpacing="-0.2"
        fill="#FFFFFF"
      >
        AI
      </text>
    </>
  );
}

export function XxllncAiLogo({
  height = 32,
  markOnly = false,
  style,
}: {
  height?: number | string;
  markOnly?: boolean;
  style?: React.CSSProperties;
}) {
  if (markOnly) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        fill="none"
        style={{ height, width: 'auto', display: 'block', ...style }}
      >
        <AiSquare />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 188 48"
      fill="none"
      style={{ height, width: 'auto', display: 'block', ...style }}
    >
      <AiSquare />
      <text
        x="60"
        y="24"
        dominantBaseline="central"
        fontFamily={AI_FONT}
        fontSize="26"
        fontWeight="700"
        letterSpacing="-0.5"
        fill="#253649"
      >
        xxllnc.ai
      </text>
    </svg>
  );
}
